export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[88vh] items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Stylized%20illustrated%20manga%20reading%20scene%20with%20an%20open%20comic%20book%20floating%20among%20warm%20orange%2C%20cream%20and%20golden%20paper%20scrolls%2C%20abstract%20artistic%20background%2C%20soft%20sunlight%20rays%2C%20storybook%20atmosphere%2C%20clean%20energetic%20composition&width=1600&height=1000&seq=hero-2026&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-background-50"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-400/90 px-4 py-1.5 text-sm font-medium text-accent-950">
            <i className="ri-smartphone-line"></i>
            换设备不断档，阅读进度随身走
          </span>

          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            尾巴漫画网
            <span className="block text-accent-300">读到哪，跟到哪</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            自动保存<span className="font-semibold text-accent-200">阅读书签</span>与历史记录，
            支持<span className="font-semibold text-accent-200">跨设备同步</span>，换手机、换平板也能
            <span className="font-semibold text-accent-200">断点续读</span>。收藏同步不丢失，打开尾巴漫画网，
            接着上次看到的地方继续看。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#recommend"
              className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-center text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即开始阅读
              <i className="ri-arrow-right-line ml-1"></i>
            </a>
            <a
              href="#features"
              className="whitespace-nowrap rounded-full border border-background-200 bg-background-50/90 px-7 py-3.5 text-center text-base font-medium text-foreground-900 transition-colors hover:bg-background-50"
            >
              了解同步功能
            </a>
          </div>
        </div>

        <dl className="mt-14 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { value: "24h", label: "进度同步" },
            { value: "3+", label: "多端兼容" },
            { value: "10k+", label: "精品漫画" },
            { value: "100%", label: "收藏不丢" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="rounded-xl border border-background-100/40 bg-black/20 px-4 py-4 backdrop-blur-sm"
            >
              <dt className="sr-only">{stat.label}</dt>
              <dd className="font-heading text-2xl text-accent-300 md:text-3xl">{stat.value}</dd>
              <dd className="mt-1 text-xs text-background-100 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}